export default () => ({
  isBusy: false,
  error: undefined,
})
